import { Credentials } from "auth";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";
import { AdminEndAction, ErrorPayload } from "./ErrorAction";

import { ClientApp } from "models";

export type AdminUpdateApp = "ADMIN_UPDATE_APP";
export const ADMIN_UPDATE_APP: AdminUpdateApp = "ADMIN_UPDATE_APP";

export type AdminUpdateAppEnd = "ADMIN_UPDATE_APP_END";
export const ADMIN_UPDATE_APP_END: AdminUpdateAppEnd = "ADMIN_UPDATE_APP_END";

export interface AdminUpdateAppAction extends Action {
    type: AdminUpdateApp;
    payload: {
        credentials: Credentials;
        app: ClientApp;
    };
}

export function adminUpdateApp(app: ClientApp): ThunkAction<any, State, any, AdminUpdateAppAction> {
    return (dispatch: Dispatch<AdminUpdateAppAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(adminUpdateAppWithCredentials(app, credentials));
    };
}

export function adminUpdateAppWithCredentials(app: ClientApp, credentials: Credentials): AdminUpdateAppAction {
    return {
        payload: {
            app,
            credentials
        },
        type: ADMIN_UPDATE_APP
    };
}

export interface AdminUpdateAppPayload extends ErrorPayload {
    app?: ClientApp;
}

export interface AdminUpdateAppEndAction extends AdminEndAction<AdminUpdateAppPayload> {
    type: AdminUpdateAppEnd;
}

export function adminUpdateAppEnd(error?: Error, app?: ClientApp) {
    return {
        payload: {
            app,
            error,
        },
        type: ADMIN_UPDATE_APP_END
    };
}
